import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../services/api";
// The session itself lives in an httpOnly cookie owned by the API.
// localStorage only caches (non-sensitive) profile/org data for instant UI;
// GET /vendor/auth/me is the source of truth on boot.
const USER_KEY = "vendor_user";
const ORG_KEY = "vendor_org";
const AuthContext = createContext({});
export function AuthProvider({ children }) {
    const [vendor, setVendor] = useState(() => {
        try {
            const stored = localStorage.getItem(USER_KEY);
            return stored ? JSON.parse(stored) : null;
        }
        catch {
            return null;
        }
    });
    const [vendorOrg, setVendorOrgState] = useState(() => {
        try {
            const stored = localStorage.getItem(ORG_KEY);
            return stored ? JSON.parse(stored) : null;
        }
        catch {
            return null;
        }
    });
    // Validate the cached session against the cookie on boot. A 401 is handled
    // by the api interceptor (clears caches, redirects to login).
    useEffect(() => {
        if (!localStorage.getItem(USER_KEY))
            return;
        api
            .get("/vendor/auth/me")
            .then((r) => {
            const u = { ...r.data.user, id: r.data.user.id || r.data.user._id || "" };
            localStorage.setItem(USER_KEY, JSON.stringify(u));
            setVendor(u);
            if (r.data.vendor) {
                localStorage.setItem(ORG_KEY, JSON.stringify(r.data.vendor));
                setVendorOrgState(r.data.vendor);
            }
        })
            .catch(() => undefined);
    }, []);
    // token param kept for call-site compatibility; the cookie set by the API
    // is the real session — the token is never persisted.
    function login(_token, v) {
        localStorage.setItem(USER_KEY, JSON.stringify(v));
        setVendor(v);
    }
    function logout() {
        api.post("/vendor/auth/logout").catch(() => undefined);
        localStorage.removeItem(USER_KEY);
        localStorage.removeItem(ORG_KEY);
        setVendor(null);
        setVendorOrgState(null);
    }
    function updateVendor(patch) {
        setVendor((v) => {
            if (!v)
                return v;
            const updated = { ...v, ...patch };
            localStorage.setItem(USER_KEY, JSON.stringify(updated));
            return updated;
        });
    }
    function setVendorOrg(org) {
        localStorage.setItem(ORG_KEY, JSON.stringify(org));
        setVendorOrgState(org);
    }
    return React.createElement(AuthContext.Provider, {
        value: {
            vendor,
            vendorOrg,
            isAuthenticated: !!vendor,
            login,
            logout,
            updateVendor,
            setVendorOrg,
        },
    }, children);
}
export function useAuth() {
    return useContext(AuthContext);
}
